import getUserInfo from 'modules/get-user-info/get-user-info';

export default function getUserPermissions() {
  return getUserInfo()?.permissions || [];
}
